import styled from 'styled-components';

export const ErrorMessage = styled.div`
	padding: 10px 12px;
	border-radius: 4px;

	color: #d32f2f;
	background-color: #fdecea;
	border: 1px solid #f5c6cb;

	font-size: 14px;
	line-height: 1.4;
	max-width: 440px;
	margin: 0 auto;
	margin-bottom: 12px;
`;
